import { Box } from "@radix-ui/themes";
import { t } from "i18next";
import { isUndefined } from "lodash";
import React, { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { useFetch } from "../../../../hooks/useFetch";
import { useAppStore } from "../../../../stores/RootStore";
import { ScreenType, TriggerType } from "../../../../types/types";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";
import { Separator } from "../../../../ui/Separator";
import Spinner from "../../../../ui/Spinner/Spinner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../../ui/Tabs/Tabs";
import TriggerSettingsTab from "./tabs/TriggerSettingsTab";


const TriggerItem = ({ id, closeEditModal }: { id: string; closeEditModal: Function }) => {
  const equipments = useAppStore((store) => store.equipments);
  // const doFetchItem = useOutletContext<Function>();
  const [{ response, isLoading, error }, doFetchCurrentItem] = useFetch(`/directories/triggers/${id}`);

  const [loading, setLoading] = useState(true);
  const [currentTrigger, setCurrentTrigger] = useState<TriggerType>();

  useEffect(() => {
    if (!id) {
      return;
    }
    setLoading(true);
    doFetchCurrentItem();
  }, [id]);

  useEffect(() => {
    if (!response) {
      return;
    }
    const responseData = response.data as unknown as TriggerType;
    setCurrentTrigger(responseData);
    setLoading(false);
  }, [response]);

  return loading || equipments == null ? (
    <Spinner />
  ) : (
    <TriggerSettingsTab id={id} currentTrigger={currentTrigger} closeEditModal={closeEditModal} />
  );
};

export default TriggerItem;
